import * as yup from 'yup'

const schema = () => {
  return yup.object().shape({
    reportSelected: yup.string(),
    partnerId: yup.mixed().when('reportSelected', {
      is: 'reportByAssessment',
      then: yup
        .object()
        .typeError('Selecione um pré-avaliado para poder gerar o relatório')
        .required('Selecione um pré-avaliado para poder gerar o relatório'),
      otherwise: yup.mixed().when('reportSelected', {
        is: 'reportByPartner',
        then: yup
          .object()
          .typeError('Selecione um fornecedor para poder gerar o relatório')
          .required('Selecione um fornecedor para poder gerar o relatório'),
        otherwise: yup.mixed().nullable(),
      }),
    }),
    auditId: yup.mixed().when('reportSelected', {
      is: (value) =>
        value === 'reportByPartner' || value === 'reportByAssessment',
      then: yup
        .object()
        .typeError('Selecione uma auditoria para poder gerar o relatório')
        .required('Selecione uma auditoria para poder gerar o relatório'),
      otherwise: yup.mixed().nullable(),
    }),
  })
}

export default schema
